import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { InfoAboutScaffoldingUnderWeatherProtection } from '../../../api';
import LabelAndTextBox from '../../molecules/labelandtextbox/LabelAndTextBox';
import './InfoAboutScaffoldingUnderWeatherProtection.css';
import DateIntervalBox from '../../molecules/labelandtextbox/DateIntervalBox';

interface InfoAboutScaffoldingUnderWeatherProtectionProp {
    infoAboutScaffoldingUnderWeatherProtection: InfoAboutScaffoldingUnderWeatherProtection;
    isWeatherProtectionProject?: boolean;
}

const InfoAboutScaffoldingUnderWeatherProtectionSection: React.FC<InfoAboutScaffoldingUnderWeatherProtectionProp> = (props) => {
    return (
        <Container className='align-items-center tablecolor mb-4'>
            <Row>
                <Col xs={12} md={6} lg={12}>
                    <div className='header-section-4-input mt-3 mb-5'>
                        <h4>4. Uppgifter om arbetet från ställningen/under väderskyddet</h4>
                    </div>
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox
                        title='Följande arbete/arbeten skall utföras från ställningen'
                        remark={props.infoAboutScaffoldingUnderWeatherProtection?.theFollowingWorkMustBeCarriedOutFromTheScaffolding}
                        onChange={(value) => {
                            props.infoAboutScaffoldingUnderWeatherProtection.theFollowingWorkMustBeCarriedOutFromTheScaffolding = value;
                        }}
                    />
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox
                        title='Följande arbete/arbeten skall utföras under väderskyddet'
                        remark={props.infoAboutScaffoldingUnderWeatherProtection?.theFollowingWorkMustBeCarriedOutUnderTheWeatherProtection}
                        placeholder={props.isWeatherProtectionProject ? 'Beskriv arbetet (obligatoriskt)' : undefined}
                        onChange={(value) => {
                            props.infoAboutScaffoldingUnderWeatherProtection.theFollowingWorkMustBeCarriedOutUnderTheWeatherProtection = value;
                        }}
                    />
                </Col>
                <Col xs={12}>
                    <DateIntervalBox
                        defaultValueFrom={props.infoAboutScaffoldingUnderWeatherProtection.scaffoldingOrWeatherProtectionStartDate ?? undefined}
                        defaultValueTo={props.infoAboutScaffoldingUnderWeatherProtection.scaffoldingOrWeatherProtectionEndDate ?? undefined}
                        title='Ställningen/väderskyddet skall användas följande tid'
                        onChangeFrom={(value) => {
                            props.infoAboutScaffoldingUnderWeatherProtection.scaffoldingOrWeatherProtectionStartDate = value.toISOString();
                        }}
                        onChangeTo={(value) => {
                            props.infoAboutScaffoldingUnderWeatherProtection.scaffoldingOrWeatherProtectionEndDate = value.toISOString();
                        }}
                    />
                </Col>
            </Row>
            <hr />
        </Container>
    );
};

export default InfoAboutScaffoldingUnderWeatherProtectionSection;
